<material-navbar
  [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')"
>
</material-navbar>
<!-- <div class="container">
  <div class="heading">Contact Us</div>
  <div class="sub-heading">
    Any question or remarks? Just write us a message!
  </div>
</div> -->
<section class="contact-us-section">
  <div class="container">
    <div class="row">
      <div class="offset-lg-1 col-lg-10 col-md-12">
        <div class="card">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="details-card">
                <h1>Contact Us</h1>
                <p>We're open for any suggestion or just to have a chat</p>
                
                <div class="infos">
                  <div class="info">
                    <div class="icon">
                      <i class="fa fa-whatsapp whatsapp" aria-hidden="true"></i> 
                    </div>
                    <div class="title">
                      <span>Whatsapp:</span>
                      <a href="tel:+917276595716">
                        +91-7276595716
                      </a>
                    </div>
                  </div>

                  <div class="info">
                    <div class="icon">
                      <i class="fa fa-envelope" aria-hidden="true"></i>
                    </div>
                    <div class="title">
                      <span>Email:</span>
                      <a href="mailto:support@jio.sh">
                        support@jio.sh
                      </a>
                    </div>
                  </div>

                  <div class="info align-flex-start">
                    <div class="icon">
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                    </div>
                    <div class="title">
                      <span>Corporate Office:</span>
                      <a href="#">
                        202, Jogani Industrial Estate, VN Purav Marg, 
                        Panchsheel Nagar, Chunabhatti, Sion, 
                        Mumbai - 400022 Maharashtra India
                      </a>
                    </div>
                  </div>
                </div>

                <h2>Follow Us</h2>

                <div class="social">
                  <a
                    href="https://api.whatsapp.com/send/?phone=917276595716&text=Hi&type=phone_number&app_absent=0"
                    target="_blank"
                    class="icon-button whatsapp"
                    ><i class="fa fa-whatsapp"></i><span></span
                  ></a>
                  <!-- <a
                    href="https://t.me/JioShURLBot"
                    target="_blank"
                    class="icon-button telegram"
                    ><i class="fa fa-telegram"></i><span></span
                  ></a> -->
                  <a
                    href="https://twitter.com/messages/compose?recipient_id=1410639908738244612&text=Hi"
                    target="_blank"
                    class="icon-button twitter"
                    ><i class="fa fa-twitter"></i><span></span
                  ></a>
                  <a
                    href="https://m.me/JioShURL"
                    target="_blank"
                    class="icon-button facebook"
                    ><i class="fa fa-facebook"></i><span></span
                  ></a>
                  <a
                    href="https://ig.me/m/jioshurl"
                    target="_blank"
                    class="icon-button instagram"
                    ><i class="fa fa-instagram"></i><span></span
                  ></a>
                </div>
              </div>
            </div>
            <div class="col-md-6 contact-form">
              <h1>Send Message</h1>
              <form
                [formGroup]="FormData"
                ngNativeValidate
                (submit)="onSubmit()"
                *ngIf="errors$ | async as errors"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="input-container">
                      <label for="firstName" trans>First Name</label>
                      <input type="text" formControlName="firstName" id="firstName" required placeholder="Enter First Name" />
                      <p class="error big-error" *ngIf="errors.firstName">
                        <span>{{ errors.firstName }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="input-container">
                      <label for="lastName" trans>Last Name</label>
                      <input type="text" formControlName="lastName" id="lastName" required placeholder="Enter Last Name" />
                      <p class="error big-error" *ngIf="errors.lastName">
                        <span>{{ errors.lastName }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="input-container">
                      <label for="login-email" trans>Email</label>
                      <input type="email" formControlName="email" id="login-email" required placeholder="Enter Email Address" />
                      <p class="error big-error" *ngIf="errors.email">
                        <span>{{ errors.email }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="input-container">
                        <label for="login-password" trans>Phone Number</label>
                        <input type="number" formControlName="phone" id="phone" required placeholder="Enter Phone Number" />
                        <p class="error big-error" *ngIf="errors.phone">
                          <span>{{ errors.phone }}</span>
                        </p>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="input-container">
                      <label for="message" trans>Message</label>
                      <textarea type="text" formControlName="comment" id="message" required placeholder="Enter Your Message"></textarea>
                      <p class="error big-error" *ngIf="errors.comment">
                        <span>{{ errors.comment }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  mat-raised-button
                  class="primary-button"
                  color="accent"
                  type="submit"
                  [disabled]="loading$ | async"
                  trans
                >
                  {{ loading$.value ? 'Submitting' : 'Submit' }}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer class="footer"></app-footer>
